import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/fonts/glyphs/glyphs.css';
import App from './App.tsx';
import { validateEnv } from './config/env.ts';
import { loadCorgeePlugin } from './lib/corgeePlugin.ts';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

validateEnv();
loadCorgeePlugin();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <App />
    </LocalizationProvider>
  </React.StrictMode>,
);
